import { HealthConnection } from '../features/sync/HealthConnection';
import { useMemo, useState } from 'react';
import { AppShell } from '../components/ui/AppShell';
import { BodyPage } from '../features/body/BodyPage';
import { HealthPage } from '../features/health/HealthPage';
import { InsightsPage } from '../features/insights/InsightsPage';
import { TodayPage } from '../features/today/TodayPage';
import { TrainingPage } from '../features/training/TrainingPage';
import { getRouteFromPath, routeToPath, type AppRoute } from './navigation';

export function App() {
  const [route, setRoute] = useState<AppRoute>(() => getRouteFromPath(window.location.pathname));

  const page = useMemo(() => {
    switch (route) {
      case 'training':
        return <TrainingPage />;
      case 'body':
        return <BodyPage />;
      case 'health':
        return <HealthPage />;
      case 'insights':
        return <InsightsPage />;
      case 'today':
        return <TodayPage />;
    }
  }, [route]);

  function handleRouteChange(nextRoute: AppRoute) {
    const nextPath = routeToPath(nextRoute);
    window.history.pushState(null, '', nextPath);
    setRoute(nextRoute);
  }

  window.onpopstate = () => setRoute(getRouteFromPath(window.location.pathname));

  return (
    <AppShell activeRoute={route} onRouteChange={handleRouteChange}>
      <HealthConnection>{page}</HealthConnection>
    </AppShell>
  );
}
